/**
 *
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 14.04.2016.
 */

import {ReduxPromiseMiddlewareTypes, SetLocaleForMoment} from '../../utils';
import {GetFavorites} from '../favorites/actions-favorites';
import {GetPurchases, GetSubscriptions} from '../purchase/actions-purchase';

import moment from 'moment';
import Cookies from 'js-cookie';

export const LOCALE_CHANGE = 'locale-change';
export const SETTINGS_STATE_CHANGE = 'settings-state-change';
export const INIT_APP = 'init-application';
export const INIT_LH_SDK = 'init-lh-sdk';
export const GET_METADATA = 'get-metadata';
export const GET_METADATA_ON_LOGIN = 'get-metadata-on-login';
export const GET_CATEGORIES = 'get-categories';
export const GET_USER_DATA = 'get-user-data';
export const GET_PARENTAL_CONTROL_STATE = 'get-parental-control-state';
export const GET_PACKAGES = 'get-packages';
export const SET_PLAYER = 'set-player';
export const OPEN_MESSAGE = 'open-message';
export const CLOSE_MESSAGE = 'close-message';
export const SHOW_TOAST = 'show-toast';
export const HIDE_TOAST = 'hide-toast';
export const GET_USER_DEVICES = 'get-user-devices';
export const SHARE_REQUEST_DONE = 'share-request-done';
export const SHARE_REQUEST_IN_AIR = 'share-request-in-air';
export const GET_BOOKMARK = 'get-bookmark-for-asset-by-id';
export const SET_BOOKMARK = 'set-bookmark-for-asset-by-id';
export const CLEAR_BOOKMARK = 'clear-bookmark-for-asset-by-id';
export const OPEN_PROFILE_FOR = 'open-profile-for-showcase';
export const CLOSE_ALL_PROFILES = 'close-all-profiles';
export const RESET = 'reset-router';

export function LocaleChange(locale) {

  Cookies.set('cur_locale', locale, {path: '/'});

  const langParse = locale.split('_');
  lh.common.config.set({'localizationLanguage': (langParse[0] || 'en').toUpperCase()});

  SetLocaleForMoment(locale);
  return {
    type: LOCALE_CHANGE,
    payload: locale
  };
}

export function SetSettingsState(state) {

  return {
    type: SETTINGS_STATE_CHANGE,
    payload: state
  };
}

export function Reset(user) {

  return {
    type: RESET
  };
}

export function InitLhSdk(user) {
  let Q;

  if (user.user !== 'guest') {
    lh.common.config.set({'authToken': user.token});

    Q = lh.system.init().then(lh.common.comet.connect.bind(lh.common.comet));
    //Q = lh.system.init();

  } else {

    Q = lh.system.auth({clientId: Config.client_id, deviceId: Config.device_id});
  }

  return {
    type: INIT_LH_SDK,
    payload: Q
  }
}

export function GetCategories() {
  let Q = lh.view.getCategories();

  return {
    type: GET_CATEGORIES,
    payload: Q
  }
}

export function GetMetadata(user) {

  let allQ = [GetCategories().payload, GetPackages().payload];

  if (user.user !== 'guest') {
    allQ.push(GetFavorites().payload);
    allQ.push(GetParentalControlStatus().payload);
    allQ.push(GetPurchases().payload);
    allQ.push(GetSubscriptions().payload);
    allQ.push(GetSubscriberData().payload);
  }

  return {
    type: GET_METADATA,
    payload: Promise.all(allQ)
  };
}

export function GetMetadataOnLogin(user) {

  let allQ = [GetCategories().payload, GetPackages().payload];

  if (user.user !== 'guest') {
    allQ.push(GetFavorites().payload);
    allQ.push(GetParentalControlStatus().payload);
    allQ.push(GetPurchases().payload);
    allQ.push(GetSubscriptions().payload);
    allQ.push(GetSubscriberData().payload);
  }

  return {
    type: GET_METADATA_ON_LOGIN,
    payload: Promise.all(allQ)
  };
}

export function GetParentalControlStatus() {
  let Q = lh.parental.getState();

  return {
    type: GET_PARENTAL_CONTROL_STATE,
    payload: Q
  }
}

export function GetSubscriberData() {

  let Q = lh.extensions.cloud.getUserData();

  return {
    type: GET_USER_DATA,
    payload: Q
  }
}

export function GetPackages() {
  let Q = lh.packages.getPackages();

  return {
    type: GET_PACKAGES,
    payload: Q
  };
}

export function InitApplication(user) {

  return {
    types: ReduxPromiseMiddlewareTypes(INIT_APP),

    // Set true for sequential actions
    sequence: true,

    // Pass actions in array
    payload: [InitLhSdk.bind(null, user), GetMetadata.bind(null, user)]
  };
}

export function SetPlayer(config) {

  return {
    type: SET_PLAYER,
    payload: config
  };
}

export function OpenMessage(message) {

  return {
    type: OPEN_MESSAGE,
    payload: message
  }
}

export function CloseMessage(message_id) {

  return {
    type: CLOSE_MESSAGE,
    payload: message_id
  }
}

export function ShowToast(message) {
  if (message.isBlocked) {
    message.timestamp = moment().unix();
  }

  return {
    type: SHOW_TOAST,
    payload: message
  }
}

export function HideToast(message_id) {

  return {
    type: HIDE_TOAST,
    payload: message_id
  }
}

export function GetDevices() {

  return {
    type: GET_USER_DEVICES,
    payload: lh.devices.getDevices()
  }
}

export function ShareRequestInAir(assetId) {

  return {
    type: SHARE_REQUEST_IN_AIR,
    payload: assetId
  };
}

export function ShareRequestDone(assetId) {

  return {
    type: SHARE_REQUEST_DONE,
    payload: assetId
  };
}

export function GetBookmark(assetId) {

  return {
    type: GET_BOOKMARK,
    meta: {
      key: assetId
    },
    payload: lh.bookmark.getBookmark(assetId)
  }
}

export function SetBookmark(assetId, position) {

  return {
    type: SET_BOOKMARK,
    meta: {
      key: assetId
    },
    payload: lh.bookmark.setBookmark(assetId, position)
  }
}

export function RemoveBookmark(assetId) {

  return {
    type: CLEAR_BOOKMARK,
    meta: {
      key: assetId
    },
    payload: lh.bookmark.clearBookmark(assetId)
  }
}

export function OpenProfileFor(showcaseId) {

  return {
    type: OPEN_PROFILE_FOR,
    payload: showcaseId
  }
}
export function CloseAllProfiles() {

  return {
    type: CLOSE_ALL_PROFILES
  }
}



// WEBPACK FOOTER //
// ./src/actions/common/actions-common.js